// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';
import { getProductProps } from 'Components/widgets/product/Product.mapper';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductTeaser } from 'Components/widgets/product-teaser/ProductTeaser';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

export type RelatedProductsCMSProps = {
  cruiseTimingPlaceholder: string,
  cruiseDurationPlaceholder: string,
  dateFormat: string,
  resortId: string,
  title: string,
  tourDurationPlaceholder: string,
};

export type RelatedProductsGQLProps = {
  config: {
    common: {
      close: string,
      thumbnailCTA: string,
    },
    price: CMSPrice,
    resort: CMSResort,
  },
  product: {
    relatedProducts: Array<{
      href: string,
      id: string,
      name: string,
      resortId: string,
      title: string,
    }>,
  },
};

type LineProps = RelatedProductsCMSProps & RelatedProductsGQLProps;

export const ProductRelatedProductsLine = ({ config, product, title }: LineProps) => {
  if (isEmpty(product.relatedProducts)) {
    return null;
  }

  return (
    <SiteContainer className="Line Line-RelatedProducts">
      <LineTitle>{title}</LineTitle>
      {product.relatedProducts.map(relatedProduct => {
        const card = {
          color: COLORS.BLUE,
          heading: {
            iconName: relatedProduct.resortId.toLowerCase(),
            title: relatedProduct.name,
          },
          link: { url: relatedProduct.href },
          text: { text: relatedProduct.title },
        };
        return (
          <article key={relatedProduct.id} className="Line Line-ProductTeaser">
            <ProductTeaser
              card={card}
              product={getProductProps({
                config,
                product: relatedProduct,
              })}
            />
          </article>
        );
      })}
    </SiteContainer>
  );
};
